import { ACDLRoute, BaseRouteConfig } from './BaseRoute';

export class AnnotationsPath extends BaseRouteConfig {
  public readonly Index = 'annotations';

  public readonly Create = new ACDLRoute<{ workspaceId: string; projectId: string }>(`${this.Path}/:projectId/create`);
  public readonly Review = new ACDLRoute<{ workspaceId: string; projectId: string }>(`${this.Path}/:projectId/review`);
}
